import * as defaults from '../theme/config.default.json';
import * as config from '../../theme/config.json';
var keys = Object.keys(defaults);
var ɵ0 = function (prev, curr) {
    var _a;
    return Object.assign(prev, (_a = {},
        _a[curr] = Object.assign(defaults[curr], config[curr] || {}),
        _a));
};
var fromDefaults = keys.reduce(ɵ0, {});
var ɵ2 = function (prop) { return keys.indexOf(prop) === -1; }, ɵ1 = function (prev, curr) {
    var _a;
    return Object.assign(prev, (_a = {},
        _a[curr] = config[curr],
        _a));
};
var preppedConfig = Object.keys(config).filter(ɵ2)
    .reduce(ɵ1, fromDefaults);
export var CATALOG_ONLY = "catalog-only";
export var FULL = "full";
export var FROM_BASELINE = "from-baseline";
export var APPLY_OVER = "apply-over";
export var USER_CHOICE = 'user-choice';
export var GRID_VIEW = 'grid-view';
export var LIST_VIEW = 'list-view';
export var RELATIVE_QUANT = 'relative';
export var ABSOLUTE_QUANT = 'absolute';
var ThemeConfig = /** @class */ (function () {
    function ThemeConfig() {
    }
    /**
     * Returns the specified configuration setting from the specified section.
     */
    ThemeConfig.get = function (section, key) {
        return preppedConfig['default'][section] && preppedConfig['default'][section][key];
    };
    Object.defineProperty(ThemeConfig, "viewMode", {
        /**
         * Returns the current view mode.
         */
        get: function () {
            if (!ThemeConfig._viewMode)
                return ThemeConfig._viewMode = ThemeConfig.get('app', 'view-mode');
            return ThemeConfig._viewMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeConfig, "itemsPerPage", {
        get: function () {
            if (!ThemeConfig._itemsPerPage)
                return ThemeConfig._itemsPerPage = ThemeConfig.get('catalog', 'items-per-page');
            return ThemeConfig._itemsPerPage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ThemeConfig, "hideInapplicableFacets", {
        get: function () {
            if (!ThemeConfig._hideInapplicableFacets)
                return ThemeConfig._hideInapplicableFacets = ThemeConfig.get('catalog', 'hide-inapplicable-facets');
            return ThemeConfig._hideInapplicableFacets;
        },
        enumerable: true,
        configurable: true
    });
    ThemeConfig._hideInapplicableFacets = false;
    return ThemeConfig;
}());
export { ThemeConfig };
export { ɵ0, ɵ2, ɵ1 };
